var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"yd-bg"},[_c('Nav',{ref:"nav",staticClass:"popup"}),_c('Home',{attrs:{"id":"Home"}}),_c('Characters',{attrs:{"id":"Characters"}}),_c('Showcase',{attrs:{"id":"Showcase"}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }